import React, {useState} from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import MsgError from "../MsgError";

export default function ModalRemove(props) {
    const {open, setOpen, setIsRemoveConfirm} = props
    const [value, setValue] = useState("")
    const [error, setError] = useState([])

    const handleClose = () => {
        setOpen(false)
    }

    const handleCloseRemove = () => {
        setError([])
        if (value !== "Eliminar") {
            setError(["Debe escribir 'Eliminar'"])
        } else {
            setIsRemoveConfirm(true)
            setOpen(false)
            setValue("")
        }
    }

    return (
        <>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>Eliminar</DialogTitle>
                <DialogContent>
                    <MsgError msg={error} />

                    <DialogContentText>
                        Para confirmar que desea eliminar este elemento, escriba <i>Eliminar</i>.
                    </DialogContentText>

                    <TextField
                        autoFocus
                        margin="dense"
                        type="text"
                        fullWidth
                        variant="standard"
                        placeholder={'Eliminar'}
                        value={value}
                        onChange={(e) => setValue(e.target.value)}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cerrar</Button>
                    <Button onClick={handleCloseRemove}>Confirmar</Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
